// import hooks
import { useContext } from "react";
import ctx from "./Environment.context.js";
export const useEnvironmentContext = () => useContext(ctx);
export default useEnvironmentContext;
